import { useState } from "react";
import { Calculation } from "@/services/backend/vbs/calculations/types/calculation";
import {
  updateVbsCalculationCache,
  useVbsCalculationResetReferenceNumberMutation,
  useVbsCalculationPatchMutation,
} from "@/services/backend/vbs/calculations/api/calculation-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { Card, CardContent } from "@/shared/components/ui/card";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * CalculationReferenceNumberCard edits the reference number of a calculation.
 * Calculations owned by another document are not numbered; nothing is
 * rendered for them.
 */
export function CalculationReferenceNumberCard({
  calculation,
  disabled = false,
}: {
  calculation: Calculation;
  disabled?: boolean;
}) {
  const patchReferenceNumber = useVbsCalculationPatchMutation();
  const resetReferenceNumber = useVbsCalculationResetReferenceNumberMutation();
  // Decided once on mount: an optimistically cleared input must not hide the
  // field of a numbered calculation.
  const [numbered] = useState(
    () => calculation.referenceNumber !== "" || !calculation.ownerId,
  );

  if (!numbered) {
    return null;
  }

  return (
    <Card>
      <CardContent>
        <ReferenceNumberField
          data={calculation}
          updateCache={updateVbsCalculationCache}
          patchMutation={patchReferenceNumber}
          resetMutation={resetReferenceNumber}
          disabled={disabled || isImmutable(calculation)}
        />
      </CardContent>
    </Card>
  );
}
